import { SelfDescription } from "./describeSelf";
import { loc } from "../i18n/survey";

enum WhyConsistency {
  Time = 'Time',
  Motivation = 'Motivation',
  Injuries = 'Injuries',
  ProgramHopping  = 'ProgramHopping',
};

const whyConsistencyQuestion = {
  visibleIf: `{describeSelf} == "${SelfDescription.StruggleConsistency}"`,
  name: 'whyConsistency',
  title: loc("quiz.whyConsistency.title"),
  description: loc("quiz.whyConsistency.description"),
  type: 'radiogroup',
  choices: [
    {
      value: WhyConsistency.Time,
      text: loc("quiz.whyConsistency.choices.time"),
    }, {
      value: WhyConsistency.Motivation,
      text: loc("quiz.whyConsistency.choices.motivation"),
    }, {
      value: WhyConsistency.Injuries,
      text: loc("quiz.whyConsistency.choices.injuries"),
    }, {
      value: WhyConsistency.ProgramHopping,
      text: loc("quiz.whyConsistency.choices.programHopping"),
    }
  ],
  isRequired: true,
  // showOtherItem: true,
};

export {
  WhyConsistency,
  whyConsistencyQuestion,
}